export default "__VITE_ASSET__Z4Tprhdf__"